import type { Framework } from "../../docs/types"

// How visitors look for their stack, shared by the homepage grid and the
// agent-directions modal. Someone who runs a store or billing panel looks for
// its name, so every plugin (and every store reached through BTCPay) comes
// first; someone building their own app looks for their language. Derived from
// each row's `type` and `family`, so a new contract row sorts itself.

export type GroupId = "stores" | "javascript" | "python" | "php" | "ruby"

export type GroupCopy = { id: GroupId; chip: string; heading: string }

export const STORES: GroupCopy = { id: "stores", chip: "Stores & billing", heading: "Stores & billing panels" }

// The four languages of "Your own app", in the order the chips show them.
export const APP_GROUPS: GroupCopy[] = [
  { id: "javascript", chip: "JavaScript", heading: "JavaScript & TypeScript" },
  { id: "python", chip: "Python", heading: "Python" },
  { id: "php", chip: "PHP", heading: "PHP" },
  { id: "ruby", chip: "Ruby", heading: "Ruby" }
]

// Medusa is a Node package, but a store owner installs it as a plugin, so the
// type decides before the language does.
export const groupOf = (framework: Framework): GroupId => {
  if (framework.type === "plugin" || framework.type === "via-btcpay") return "stores"
  switch (framework.family) {
    case "node":
      return "javascript"
    case "python":
      return "python"
    case "php":
      return "php"
    case "rails":
      return "ruby"
    default:
      return "stores"
  }
}
